import { Box, Button, Center, Group, Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import { LuArrowLeft, LuLayoutDashboard } from 'react-icons/lu'
import { DepthContour } from './marina/DepthContour'
import { EmptyState } from './marina/EmptyState'
import { OmbakPattern } from './marina/OmbakPattern'

/**
 * 404 — Pelabuhan-styled "you've drifted off course" page.
 * Lighthouse illustration on depth-contour backdrop with maritime metaphor.
 */
export function NotFound() {
  return (
    <Box style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      {/* Ambient depth-contour backdrop, very subtle */}
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          color: 'var(--mantine-color-laut-7)',
        }}
      >
        <DepthContour size={900} opacity={0.1} rings={8} />
      </Box>

      {/* Ombak watermark at bottom */}
      <Box
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          color: 'var(--mantine-color-laut-7)',
          pointerEvents: 'none',
        }}
      >
        <OmbakPattern height={42} opacity={0.16} />
      </Box>

      <Center mih="100vh" style={{ position: 'relative' }}>
        <Stack align="center" gap="lg" maw={520} px="md">
          <EmptyState kind="lighthouse" size="lg" backdrop={false} title="" description="" />

          <Stack gap={6} align="center">
            <Text size="xs" tt="uppercase" c="dimmed" fw={600} style={{ letterSpacing: '0.18em' }}>
              404 · Terdampar
            </Text>
            <Title
              order={1}
              ta="center"
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                fontWeight: 600,
                letterSpacing: '-0.02em',
                lineHeight: 1.1,
              }}
            >
              Anda terdampar di pulau yang tak dikenal
            </Title>
            <Text c="dimmed" size="sm" ta="center" maw={420}>
              Halaman yang Anda cari mungkin telah berlayar pergi atau tidak pernah ada. Mari kembali ke dermaga.
            </Text>
          </Stack>

          <Group gap="sm">
            <Button component={Link} to="/" leftSection={<LuArrowLeft size={16} />} variant="default">
              Kembali ke Beranda
            </Button>
            <Button component={Link} to="/dashboard" leftSection={<LuLayoutDashboard size={16} />} color="laut">
              Ke Dashboard
            </Button>
          </Group>
        </Stack>
      </Center>
    </Box>
  )
}
